import { useCallback, useId, useMemo, useState } from "react";

import { debounce } from "../utils/helpers/debounce";

export const useSelect = ({
  data,
  selectName,
  name,
  handleChange,
  initialSelectedItem,
  allOption,
  selectOption,
  fingerPrintOption,
}) => {
  const [selectedItem, setSelectedItem] = useState(initialSelectedItem);

  const [isOpen, setIsOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const selectIdInput = useId();
  const selectIdSelect = useId();

  const containsText = useCallback(
    (text, searchText) =>
      text?.toLowerCase().trim().indexOf(searchText.toLowerCase().trim()) > -1,
    [],
  );

  const displayedData = useMemo(() => {
    return data?.filter(option => containsText(option[selectName], searchText));
  }, [data, searchText, selectName, containsText]);

  const handleSelectionChange = useCallback(
    (event, multiple) => {
      const { value } = event.target;

      if (multiple) {
        const selectedIds = Array.isArray(value) ? value : [value];
        const selectedItems = data.filter(item =>
          selectedIds.includes(item[selectOption]),
        );

        setSelectedItem(selectedItems);
        handleChange({
          target: {
            name,
            value: selectedItems.map(item => item[selectOption]),
          },
        });
      } else {
        const selected =
          data.find(item => item[selectOption] === value) ||
          allOption ||
          fingerPrintOption;

        setSelectedItem(selected);
        handleChange({
          target: {
            name,
            value: selected ? selected[selectOption] : "",
          },
        });
      }
    },
    [data, handleChange, name, selectOption, allOption, fingerPrintOption],
  );

  const handleSearchTextChange = useCallback(
    debounce(event => {
      setSearchText(event.target.value);
    }, 300),
    [],
  );

  return {
    selectedItem,
    isOpen,
    setIsOpen,
    displayedData,
    handleSelectionChange,
    handleSearchTextChange,
    selectIdInput,
    selectIdSelect,
    setSearchText,
    setSelectedItem,
  };
};
